export default __webpack_public_path__ + "static/media/demo2.176b94bc.png";